// Again product card: colour dots swap the card picture (hover/focus), click opens that colour.
class AgCard extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    const main = this.querySelector('[data-main]');
    if (!main) return;
    const original = main.currentSrc || main.src;
    const dots = [...this.querySelectorAll('.ag-card__dot')];
    const show = (dot) => {
      dots.forEach((d) => d.classList.toggle('is-active', d === dot));
      main.removeAttribute('srcset');
      main.src = dot.dataset.img;
      this.classList.add('is-swatched');
    };
    dots.forEach((dot) => {
      dot.addEventListener('pointerenter', () => show(dot));
      dot.addEventListener('focus', () => show(dot));
    });
    this.querySelector('.ag-card__dots')?.addEventListener('pointerleave', () => {
      if (!dots.length) return;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === 0));
      main.src = original;
      this.classList.remove('is-swatched');
    });
  }
}
if (!customElements.get('ag-card')) customElements.define('ag-card', AgCard);
